module.exports = __webpack_public_path__ + "static/img/qrCode2.86ba3677.png";